import React from "react";
import { IMAGE_URL } from "../../api-urls";

const ImageGallery = ({
  isMobile, bigImage, smallImages, variantImages, selectedSmallImageIndex, imagesPerView,
  remainingImages, handleSmallImageClick, getVisibleCarouselImages, bigImageHandlers,
  carouselHandlers, showMagnifier, setShowMagnifier, setImgWidth, setImgHeight, setXY,
  magnifierWidth, magnifierHeight, zoomLevel, x, y, imgWidth, imgHeight
}) => (
  <div className="flex flex-col lg:flex-row gap-4 lg:gap-9 px-2 lg:px-0 relative left-1 lg:left-0 overflow-y-auto">
    {/* Mobile View */}
    <div className="lg:hidden w-full h-[400px] md:h-[600px] relative" {...bigImageHandlers}>
      <img src={IMAGE_URL + bigImage} alt="Big Dress" className="w-full h-full object-cover" />
      <div className="absolute bottom-4 left-4 bg-gray-800 bg-opacity-70 text-white rounded-full px-3 py-1 text-sm font-medium">
        {selectedSmallImageIndex + 1} / {variantImages.length}
      </div>
    </div>
    <div className="lg:hidden w-full relative" {...carouselHandlers}>
      {isMobile && (
        <div className="flex justify-between gap-2 w-full py-2">
          {getVisibleCarouselImages().map((image, index) => (
            <img
              key={index}
              src={IMAGE_URL + image}
              alt={`Thumbnail ${index + 1}`}
              className={`h-auto object-cover border border-primary1 flex-shrink-0 ${
                index === selectedSmallImageIndex ? 'border-2 opacity-100' : 'opacity-70'
              }`}
              style={{ width: `${100 / smallImages.length}%` }}
              onClick={() => handleSmallImageClick(index)}
            />
          ))}
        </div>
      )}
    </div>

    {/* Desktop View */}
    <div className="hidden lg:flex flex-col gap-6 w-1/6 h-[84vh] xl:h-[87vh] relative lg:top-12 px-2 cursor-pointer">
      {smallImages.slice(0, Math.min(imagesPerView, smallImages.length)).map((image, index) => (
        <div
          key={index}
          className="relative flex-1"
          style={{ height: `${100 / Math.min(imagesPerView, smallImages.length)}%` }}
        >
          <img
            src={IMAGE_URL + bigImage}
            alt={`Thumbnail ${index + 1}`}
            className={`w-full h-full object-cover cursor-pointer border border-primary1 ${
              selectedSmallImageIndex === index ? 'opacity-100 border-2' : 'opacity-70'
            }`}
            onClick={() => handleSmallImageClick(index)}
          />
          {index === Math.min(imagesPerView - 1, smallImages.length - 1) && (
            <div
              className="absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 text-hcolor text-xl font-semibold bg-white bg-opacity-70 px-2 rounded"
              onClick={() => handleSmallImageClick(index)}
            >
              +{remainingImages}
            </div>
          )}
        </div>
      ))}
    </div>

    <div className="hidden lg:flex w-3/4 h-[94vh] xl:h-[98vh] 2xl:h-[100vh] py-12 relative">
      <img
        src={IMAGE_URL + bigImage}
        alt="Big Dress"
        className="w-full h-full object-cover cursor-grab"
        onMouseEnter={(e) => {
          const elem = e.currentTarget;
          const { width, height } = elem.getBoundingClientRect();
          setImgWidth(width);
          setImgHeight(height);
          setShowMagnifier(true);
        }}
        onMouseMove={(e) => {
          const elem = e.currentTarget;
          const { top, left } = elem.getBoundingClientRect();
          const x = e.pageX - left - window.pageXOffset;
          const y = e.pageY - top - window.pageYOffset;
          setXY([x, y]);
        }}
        onMouseLeave={() => setShowMagnifier(false)}
      />
      {showMagnifier && (
        <div
          className="absolute top-10 left-0 h-full border border-gray-200 bg-white pointer-events-none"
          style={{
            width: `${magnifierWidth}px`,
            height: `${magnifierHeight}px`,
            backgroundImage: `url('${IMAGE_URL + bigImage}')`,
            backgroundSize: `${imgWidth * zoomLevel}px ${imgHeight * zoomLevel}px`,
            backgroundPositionX: `${-x * zoomLevel + magnifierWidth / 2}px`,
            backgroundPositionY: `${-y * zoomLevel + magnifierHeight / 2}px`,
            zIndex: 10,
          }}
        />
      )}
    </div>
  </div>
);

export default ImageGallery;
